<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="空余时间"
    width="800px"
  >
  <div>
     <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       <el-row  v-for="(item, index) in formData.free_times" :key="index">
            <el-col :span="16">
                <el-form-item label="" :prop="'free_times.' + index + ''" :rules="rules.times">
                  <el-date-picker
                      type="daterange"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      v-model="formData.free_times[index]"
                      range-separator="至"
                      start-placeholder="开始时间"
                      end-placeholder="结束时间"
                      placeholder="选择时间范围">
                    </el-date-picker>
                </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-button @click="del(index)">删除</el-button>
            </el-col>
        </el-row>

      <el-form-item>
        <el-button @click="addComponents">添加时间段</el-button>
      </el-form-item>

     </el-form>
    
  </div>

  <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
  </span>

  </el-dialog>
</template>

<script>
import { recommendupdate ,themeImg} from "@/api/user/index.js";


export default {
    name: "Director-Work-CLock",
    data() {
      return {
        visible: false,
        rules: {
          
          times: [
                {required: true, message: '请选择时间', trigger: 'change'}
           ],
       },

      formData:{
        free_times:[]

        },
     
      }
    },
 

    methods: {
      init(free_times) {
        this.formData.free_times=free_times;
        this.visible = true;
      },
      handleClose() {
        this.visible = false;
        this.$refs["form"].resetFields();

      },

      addComponents(){
        this.formData.free_times.push("");
      },

      del(index){
        this.formData.free_times.splice(index,1);
      },
    
      submit(){
        var that=this;
        this.$refs["form"].validate((valid) => {
            if (valid) {
              var free_times= that.formData.free_times;

              recommendupdate({'free_times':free_times}).then((response) => {
                console.log(response);
                if(response.code==200){
                  this.$message({
                    message: "提交成功",
                    type: 'success'

                  });
                  that.$emit('refresh');
                  that.visible = false;
                
                }else{
                  this.$message({
                    message: response.msg?response.msg:"提交失败",
                  });
                }
              });
            } 
          });
       },
      
    }
  }
</script>
<style lang="scss" scoped>
::v-deep .main_box{
  background: #EEEBEC !important; 
}
.head{
  display: flex;
  justify-content: flex-start;
  background: #ffffff;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  img{
    width: 120px;
    height: 120px;
    margin-right: 20px;
  }
  .title{
    margin-top: 20px;
    font-weight: bold;
    font-size: 20px;
  }
  .desc{
    margin-top: 10px;

  }
}

.cont{
  padding: 20px;
  box-shadow: 0px 0px 13px rgba(0,0,0,0.15);
  margin-top: 20px;

  .clock-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      display: flex;
      justify-content: space-between;
      background: #F6F6F6;
      align-items: center;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .job{
        max-width: 300px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      .op{
        display:flex;
        align-items: center;
      }
      .btns{
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
    }
  }


  .edit-list{
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    flex-flow: wrap;
 
    .unit{
      background: #F6F6F6;
      padding: 10px 30px;
      min-width: calc((100% - 160px) / 2);
      max-width: calc((100% - 160px) / 2);
      flex: 1;
      margin-bottom: 20px;

      .title{
        text-align: center;
      }

      .desc{
        text-align: center;
      }

      .btns{
        text-align: center;
        align-items: center;
        margin-left: 20px;
        span{
          line-height: 30px;
          text-align: center;
          border-radius: 4px;
          color: #4c71db;
          border: none;
          margin-left: 20px;
          background: none;
        }
      }
      


    }
  }
}
</style>